import { HierarchyContextProps } from "../interface";

/**
 * Checks domain replacements for validation issues and updates save blockers.
 *
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with validation warnings
 */
export const hcr_checkDRs = (state: HierarchyContextProps): HierarchyContextProps => {
  if (state.hierarchy) {
    const warnings = new Set<{ airid: string; warningText: string }>();
    state.hierarchy.domainReplacements.forEach((dr) => {
      if (dr.oldText === "") {
        warnings.add({
          airid: dr.airid,
          warningText: "Missing text will be ignored",
        });
      }
      if (
        state.hierarchy!.domainReplacements.filter(
          (o) => o.domain === dr.domain && o.oldText === dr.oldText,
        ).length > 1
      ) {
        warnings.add({
          airid: dr.airid,
          warningText: "Duplicates will cause unpredictable results",
        });
      }
      if (
        dr.oldText !== "" &&
        dr.newText.lines
          .map((l) => l.textBlocks.map((b) => b.text).join(""))
          .join("\n")
          .includes(dr.oldText)
      ) {
        warnings.add({
          airid: dr.airid,
          warningText: "New text cannot contain the original text",
        });
      }
    });
    return {
      ...state,
      saveBlockers: {
        ...state.saveBlockers,
        domainReplacements: warnings,
      },
    };
  }
  return state;
};
